// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixWindow from 'wix-window';
$w.onReady(function () {
	//TODO: write your page related code here...

});



export function button31_click(event) {
	 $w("#columnStrip26").expand();
	$w("#button31").hide();
	$w("#button31").collapse();
}

export function explainervideo_click(event) {
	wixWindow.trackEvent("CustomEvent", {
    "event": "Watch Explainer Video",
    "eventCategory": "Button Click",
  } );
}